import React, { useState, useEffect } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts/highstock'
import { Card, Grid, Checkbox } from '@scuf/common'
import useDAPC from './useDAPC'

const TrenGasesDAPC = ({ height, getData }) => {
    const { checkTG, fCalculateLenghtTG, setCheckTG, fCalculateEnabledDisabledTG } = useDAPC(null)
    const [option, setOption] = useState(null)

    const categories = [
        'Emisiones SO2',
        'Flujo Aire Soplador principal',
        'Posición Plato RFS (%)',
        'Presión Plato RFS',
        'Presión Tostador',
        'Presión Tren de gases',
        'Velocidad SOP-01',
        'Velocidad Ven01',
        'Vibraciones Ven01',
        'VV Dilución UCV-002'
    ]
    const colors = ['#1792e5', '#7eb338', '#ffc627', '#f37021', '#ee3124', '#9b59b6', '#b65959', '#8dcdff', '#9e9e9e', '#1792e5']

    useEffect(() => {
        if (getData && getData.length > 0) {
            let _labels = [], _data = [], band = 0, _height = 100 / fCalculateLenghtTG(), top = 0

            for (let index = 0; index < categories.length; index++) {
                if (fCalculateEnabledDisabledTG()[index] === 1) {
                    _data.push({
                        type: 'line',
                        name: categories[index],
                        data: getData.filter(n => n.Detalle === categories[index]).map((x, i) => [new Date(x.FechaHora).getTime(), x.Valor]),
                        yAxis: band,
                        color: colors[index],
                        gridLineWidth: 0
                    })
                    band = band + 1

                    _labels.push({
                        labels: {
                            align: 'right',
                            x: -3
                        },
                        title: {
                            text: categories[index]
                        },
                        height: _height + '%',
                        top: top + '%',
                        resize: {
                            enabled: true
                        },
                        gridLineWidth: 0,
                        offset: 0,
                    })

                    top = top + _height

                    if (fCalculateLenghtTG() === band) {
                        setOption(
                            {
                                rangeSelector: { buttons: [] },
                                title: {
                                    text: ''
                                },
                                yAxis: _labels,

                                tooltip: {
                                    split: true
                                },
                                series: _data,
                                credits: {
                                    enabled: false
                                }
                            }
                        )
                    }
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkTG])

    return (
        <>
            <Grid.Column width={10} sWidth={12} xsWidth={12} className='div-pe-0px-xs'>
                <Card className='m-0 p-0'>
                    {
                        option && (checkTG.btn1 || checkTG.btn2 || checkTG.btn3 || checkTG.btn4 || checkTG.btn5 || checkTG.btn6 || checkTG.btn7 || checkTG.btn8 || checkTG.btn9 || checkTG.btn10) ?
                            <div className='line-custom'>
                                <HighchartsReact
                                    constructorType='stockChart'
                                    style={{ width: '100%' }}
                                    highcharts={Highcharts}
                                    options={option}
                                    containerProps={{ style: { height: height, width: '100%' } }}
                                />
                            </div>
                            :
                            <div className='letter-origin'>...No hay datos</div>
                    }
                </Card>
            </Grid.Column>
            <Grid.Column width={2} sWidth={12} xsWidth={12} className='div-ps-0px-xs'>
                <Card className='m-0 p-0'>
                    <Card.Header>
                        <div className='letter-origin mb-2'>VARIABLES</div>
                    </Card.Header>
                    <Grid.Row>
                        <div className='mx-2'>
                            <Checkbox label="Seleccionar Todo" toggle={true} checked={checkTG.btn1 && checkTG.btn2 && checkTG.btn3 && checkTG.btn4 && checkTG.btn5 && checkTG.btn6 && checkTG.btn7 && checkTG.btn8 && checkTG.btn9 && checkTG.btn10 ? true : false}
                                onChange={(checked) =>
                                    checked ?
                                        setCheckTG({ btn1: true, btn2: true, btn3: true, btn4: true, btn5: true, btn6: true, btn7: true, btn8: true, btn9: true, btn10: true })
                                        :
                                        setCheckTG({ btn1: false, btn2: false, btn3: false, btn4: false, btn5: false, btn6: false, btn7: false, btn8: false, btn9: false, btn10: false })
                                }
                            />
                            <Checkbox label="Emisiones SO2" onChange={(checked) => { setCheckTG({ ...checkTG, btn1: checked }) }} checked={checkTG.btn1} />
                            <Checkbox label="Flujo Aire Sopl Prin" onChange={(checked) => setCheckTG({ ...checkTG, btn2: checked })} checked={checkTG.btn2} />
                            <Checkbox label="Posición Plato RFS (%)" onChange={(checked) => setCheckTG({ ...checkTG, btn3: checked })} checked={checkTG.btn3} />
                            <Checkbox label="Presión Plato RFS" onChange={(checked) => { setCheckTG({ ...checkTG, btn4: checked }) }} checked={checkTG.btn4} />
                            <Checkbox label="Presión Tostador" onChange={(checked) => setCheckTG({ ...checkTG, btn5: checked })} checked={checkTG.btn5} />
                            <Checkbox label="Presión Tren de gases" onChange={(checked) => setCheckTG({ ...checkTG, btn6: checked })} checked={checkTG.btn6} />
                            <Checkbox label="Velocidad SOP-01" onChange={(checked) => { setCheckTG({ ...checkTG, btn7: checked }) }} checked={checkTG.btn7} />
                            <Checkbox label="Velocidad Ven01" onChange={(checked) => setCheckTG({ ...checkTG, btn8: checked })} checked={checkTG.btn8} />
                            <Checkbox label="Vibraciones Ven01" onChange={(checked) => setCheckTG({ ...checkTG, btn9: checked })} checked={checkTG.btn9} />
                            <Checkbox label="VV Dilución UCV-002" onChange={(checked) => setCheckTG({ ...checkTG, btn10: checked })} checked={checkTG.btn10} />
                        </div>
                    </Grid.Row>
                </Card>
            </Grid.Column>
        </>
    )
}

export default TrenGasesDAPC